import axios from 'axios'
import Cookie from 'js-cookie'
import {showMask} from 'util'
import {message} from 'ant-design-vue'
import XEUtils from "xe-utils/index";

// 跨域认证信息 header 名
const xsrfHeaderName = 'Authorization'

axios.defaults.timeout = 1200000
// axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = xsrfHeaderName
axios.defaults.xsrfCookieName = xsrfHeaderName

// 认证类型
const AUTH_TYPE = {
	BEARER: 'Bearer',
	BASIC: 'basic',
	AUTH1: 'auth1',
	AUTH2: 'auth2',
}

// http method
const METHOD = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
	DELETE: 'delete'
}


/**
 * 通用请求封装
 * @param url 请求地址
 * @param method {string} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
async function getSyncJson(url, method = 'get', params) {
	method = method.toLocaleLowerCase();
	switch (method) {
		case METHOD.POST:
		case METHOD.PUT:
		case METHOD.DELETE:
			return doAxiosCall(method, url, params);
		case METHOD.GET:
		default:
			return doAxiosCall(method, url, {params});
	}
}

/**
 * 获取详情页数据
 * @param url
 * @param params
 * @return {Promise<unknown>}
 */
async function getFormDetail(url, params) {
	return doAxiosCall('get', url, {params});
}

/**
 * 保存详情页数据
 * @param url
 * @param result
 * @return {Promise<unknown>}
 */
async function saveFormDetail(url, result) {
	return doAxiosCall('post', url, result);
}

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
async function request(url, method, params) {
	switch (method) {
		case METHOD.POST:
		case METHOD.PUT:
		case METHOD.DELETE:
			return doAxiosCall(method, url, params);
		case METHOD.GET:
		default:
			return doAxiosCall(method, url, {params});
	}
}


/**
 * 带全局遮罩的axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @param message {String} 提示消息
 * @returns {Promise<AxiosResponse<T>>}
 */
async function requestMasked(url, method, params, message) {
	let promise = null;
	switch (method) {
		case METHOD.POST:
		case METHOD.PUT:
		case METHOD.DELETE:
			promise = doAxiosCall(method, url, params);
			break;
		case METHOD.GET:
		default:
			promise = doAxiosCall(method, url, {params});
			break;
	}

	// 显示遮罩
	const mask = showMask(message);
	return new Promise((resolve, reject) => {
		Promise.all([promise])
				.then(resolve)
				.catch(reject)
				.finally(() => {
					// 关闭遮罩
					mask.close();
				});
	});
}

/**
 * 执行axios调用并解析返回值
 * @param method
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
async function doAxiosCall(method, url, params) {
	return new Promise((resolve, reject) => {
		axios[method](url, params)
				.then(response => {
					if (response) {
						if (typeof response.status === "number" && response.request && response.headers && response.data) {
							// 如果返回数据的格式是axios的格式，则取出其中的data部分
							const res = response.data;
							if (res && res.code >= 200 && res.code < 300) {
								resolve(res);
							} else {
								// console.log(res.msg)
								message.error(res.msg || res.response.response.data.msg)
								reject(res || {
									code: 500,
									msg: '服务器返回了无效的数据',
									// msg: "res.msg || res.response.response.data.msg",
									response: response
								});
							}
						} else {
							// 如果返回数据格式不能识别或缺少data，则直接返回response
							if (typeof console !== "undefined" && console && typeof console.warn === "function") {
								console.warn("错误的返回值格式", response);
							}
							resolve(response);
						}
					} else {
						message.error('服务器未返回数据')
						reject({
							code: 0,
							msg: "服务器未返回数据"
						});
					}
				})
				.catch(res => {
					if (res.response.status === 401) {//登录失效
						reject({
							code: 401,
							msg: "登录失效",
							response: res
						});
						if (res.response.status === 401) {
							message.error('登录失效');
							document.cookie = "Authorization=Bearertoken";
							setTimeout(() => {
								location.hash = '/login'
								// location.href = process.env.VUE_APP_LOGOUT_SERVICE_URL
							}, 2000)
						}
					} else {
						reject(res && typeof res.code === "number" ? res : {code: 500, response: res});
					}
				});
	});
}

async function requestDo(url, method, params) {
	switch (method) {
		case METHOD.POST:
		case METHOD.PUT:
		case METHOD.DELETE:
			return doAxiosCallDo(method, url, params);
		case METHOD.GET:
		default:
			return doAxiosCallDo(method, url, {params});
	}
}

async function doAxiosCallDo(method, url, params) {
	return new Promise((resolve, reject) => {
		axios[method](url, params)
				.then(response => {
					if (response) {
						if (typeof response.status == "number" && response.request && response.headers && response.data) {
							// 如果返回数据的格式是axios的格式，则取出其中的data部分
							const res = response.data;
							if (res && res.code >= 200 && res.code < 300) {
								resolve(res);
							} else {
								reject(res || {
									code: 500,
									msg: "服务器返回了无效的数据",
									response: response
								});
							}
						} else {
							// 如果返回数据格式不能识别或缺少data，则直接返回response
							if (typeof console !== "undefined" && console && typeof console.warn === "function") {
								console.warn("错误的返回值格式", response);
							}
							resolve(response);
						}
					} else {
						reject({
							code: 0,
							msg: "服务器未返回数据"
						});
					}
				})
				.catch(res => {
					reject(res && res.response && res.response.data && typeof res.response.data.code === "number" ? res.response.data : {
						code: 500,
						response: res.response.data
					});
				});
	});
}

/**
 * 执行axios调用并解析返回值
 * @param method
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
async function downFile(url, method, params) {
	return new Promise((resolve, reject) => {
		axios({
			url,
			method,
			data: params,
			responseType: 'blob'
		}).then(response => {
			resolve(response);
		}).catch(res => {
			reject(res);
		});
	});
}


/**
 * 执行axios调用并解析返回值
 * @param method
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
async function upFile(url, method, params) {
	return new Promise((resolve, reject) => {
		axios[method](url, params,
				{
					headers: {'Content-Type': 'multipart/form-data'},
				}).then(response => {
			resolve(response);
		}).catch(res => {
			reject(res);
		});
	});
}

async function exportExcelJasper(url, options) {
	let defaultName = '导出-' + XEUtils.toDateString(new Date(), 'yyyyMMddHHssmm');
	options = {
		filename: options && options.filename ? options.filename : defaultName,
		sheetName: options && options.sheetName ? options.sheetName : 'Sheet1',
		containHeader: options && options.isHeader ? options.isHeader : false,
		original: options && options.original ? options.original : true,
	}
	// 传给服务端的参数
	const body = {
		filename: options.filename,
		sheetName: options.sheetName,
		containHeader: options.containHeader,
		original: options.original,
	}
	// 开始服务端导出
	await downFile(url, METHOD.POST, body).then(blob => {
		message.success('导出成功，开始下载');
		let downloadElement = document.createElement("a");
		let href = window.URL.createObjectURL(blob.data); //创建下载的链接
		downloadElement.href = href;
		downloadElement.download = options.filename + '.xlsx'; //下载后文件名
		document.body.appendChild(downloadElement);
		downloadElement.click(); //点击下载
		document.body.removeChild(downloadElement); //下载完成移除元素
		window.URL.revokeObjectURL(href); //释放掉blob对象
	}).catch(e => {
		console.error('导出失败:' + e);
		message.error('导出失败');
	})
}

/**
 * 设置认证信息
 * @param auth {Object}
 * @param authType {AUTH_TYPE} 认证类型，默认：{AUTH_TYPE.BEARER}
 */
function setAuthorization(auth, authType = AUTH_TYPE.BEARER) {
	switch (authType) {
		case AUTH_TYPE.BEARER:
			Cookie.set(xsrfHeaderName, 'Bearer ' + auth.token, {expires: auth.expireAt})
			break
		case AUTH_TYPE.BASIC:
		case AUTH_TYPE.AUTH1:
		case AUTH_TYPE.AUTH2:
		default:
			break
	}
}

/**
 * 移出认证信息
 * @param authType {AUTH_TYPE} 认证类型
 */
function removeAuthorization(authType = AUTH_TYPE.BEARER) {
	switch (authType) {
		case AUTH_TYPE.BEARER:
			Cookie.remove(xsrfHeaderName)
			break
		case AUTH_TYPE.BASIC:
		case AUTH_TYPE.AUTH1:
		case AUTH_TYPE.AUTH2:
		default:
			break
	}
}

/**
 * 获取登录token
 * @param authType
 */
function getToken(authType = AUTH_TYPE.BEARER) {
	let auth = ""
	switch (authType) {
		case AUTH_TYPE.BEARER:
			auth = Cookie.get(xsrfHeaderName)
			if (auth) {
				const token = auth.substring(AUTH_TYPE.BEARER.length + 1)
				return token
			}
			break
		case AUTH_TYPE.BASIC:
		case AUTH_TYPE.AUTH1:
		case AUTH_TYPE.AUTH2:
		default:
			break;
	}
	return null
}

/**
 * 检查认证信息
 * @param authType
 * @returns {boolean}
 */
function checkAuthorization(authType = AUTH_TYPE.BEARER) {
	switch (authType) {
		case AUTH_TYPE.BEARER:
			if (Cookie.get(xsrfHeaderName)) {
				return true
			}
			break
		case AUTH_TYPE.BASIC:
		case AUTH_TYPE.AUTH1:
		case AUTH_TYPE.AUTH2:
		default:
			break
	}
	return false
}

/**
 * 加载 axios 拦截器
 * @param interceptors
 * @param options
 */
function loadInterceptors(interceptors, options) {
	const {request, response} = interceptors
	// 加载请求拦截器
	request.forEach(item => {
		let {onFulfilled, onRejected} = item
		if (!onFulfilled || typeof onFulfilled !== 'function') {
			onFulfilled = config => config
		}
		if (!onRejected || typeof onRejected !== 'function') {
			onRejected = error => Promise.reject(error)
		}
		axios.interceptors.request.use(
				config => onFulfilled(config, options),
				error => onRejected(error, options)
		)
	})
	// 加载响应拦截器
	response.forEach(item => {
		let {onFulfilled, onRejected} = item
		if (!onFulfilled || typeof onFulfilled !== 'function') {
			onFulfilled = response => response
		}
		if (!onRejected || typeof onRejected !== 'function') {
			onRejected = error => Promise.reject(error)
		}
		axios.interceptors.response.use(
				response => onFulfilled(response, options),
				error => onRejected(error, options)
		)
	})
}

/**
 * 解析 url 中的参数
 * @param url
 * @returns {Object}
 */
function parseUrlParams(url) {
	const params = {}
	if (!url || url === '' || typeof url !== 'string') {
		return params
	}
	const paramsStr = url.split('?')[1]
	if (!paramsStr) {
		return params
	}
	const paramsArr = paramsStr.replace(/&|=/g, ' ').split(' ')
	for (let i = 0; i < paramsArr.length / 2; i++) {
		const value = paramsArr[i * 2 + 1]
		params[paramsArr[i * 2]] = value === 'true' ? true : (value === 'false' ? false : value)
	}
	return params
}

export {
	METHOD,
	AUTH_TYPE,
	request,
	requestMasked,
	requestDo,
	setAuthorization,
	removeAuthorization,
	checkAuthorization,
	loadInterceptors,
	parseUrlParams,
	getToken,
	downFile,
	upFile,
	exportExcelJasper,
	getSyncJson,
	getFormDetail,
	saveFormDetail
}
